import axios from 'axios'
import { API_URL } from '../../../../setup/config/env'

export function createOrUpdateKnowledge(knowledge) {
  return dispatch => {
    return axios.post(API_URL+"/api/knowledgeCategory/createOrUpdate", {...knowledge})
  }
}

export function removeKnowledge({ knowledgeCategoryId }) {
  return dispatch => {
    return axios.post(API_URL+"/api/knowledgeCategory/delete", {"_id":knowledgeCategoryId})
  }
}

export function createOrUpdateIntent(intent) {
    return dispatch => {
      return axios.post(API_URL+"/api/intents/createOrUpdate", {...intent})
    }
}
  
export function removeIntent({ intentId }) {
    return dispatch => {
      return axios.post(API_URL+"/api/intents/delete", {"_id":intentId})
    }
}

export function trainIntents() {
  return dispatch => {
  return axios.post(API_URL+"/api/intents/train")
}
}

export function createOrUpdatebotSetting(botSetting) {
  return dispatch => {
    return axios.post(API_URL+"/api/bot/createOrUpdate", {...botSetting})
  }
}

export function generateSuggestions({ intentName }) {
  return dispatch => {
    return axios.post(API_URL+"/api/intents/generateSuggestions", { intentName })
  }
}
